import { render, staticRenderFns } from "./PartMenu.vue?vue&type=template&id=9eff07d4&"
import script from "./PartMenu.vue?vue&type=script&lang=ts&"
export * from "./PartMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports